import AccountBoxIcon from '@mui/icons-material/AccountBox'
import AllOutIcon from '@mui/icons-material/AllOut'
import EventIcon from '@mui/icons-material/Event'
import LogoutIcon from '@mui/icons-material/Logout'
import MenuIcon from '@mui/icons-material/Menu'
import QuizIcon from '@mui/icons-material/Quiz'
import { IconButton, Stack, SvgIconTypeMap, Typography } from '@mui/material'
import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import Drawer from '@mui/material/Drawer'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import { OverridableComponent } from '@mui/material/OverridableComponent'
import { useAppDispatch } from 'app/hooks'
import { logout } from 'app/slices/UI'
import { TokenInfo } from 'interface'
import * as React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

interface Props {
  auth: TokenInfo
}

function MenuItem({
  text,
  Icon = AllOutIcon,
  onClick,
}: {
  text: string
  Icon?: OverridableComponent<SvgIconTypeMap<{}, 'svg'>> & {
    muiName: string
  }
  onClick: () => void
}) {
  return (
    <ListItem disablePadding onClick={onClick}>
      <ListItemButton
        sx={{
          px: 1,
          py: 0.8,
        }}
      >
        <ListItemIcon
          sx={{
            mr: 1,
            minWidth: 0,
          }}
        >
          <Icon />
        </ListItemIcon>
        <ListItemText primary={text} />
      </ListItemButton>
    </ListItem>
  )
}

export default function TemporaryMenu({ auth }: Props) {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const [open, setOpen] = React.useState(false)
  const urlQuery = new URLSearchParams(useLocation().search)
  const list = () => (
    <Box
      sx={{ minWidth: 160, maxWidth: 300, width: '50vw' }}
      role="presentation"
    >
      <Stack p={1}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 'bold',
            textTransform: 'capitalize',
          }}
        >
          {auth.name}
        </Typography>
      </Stack>
      <List
        disablePadding
        onClick={() => setOpen(false)}
        onKeyDown={(event) => {
          if (
            event.type === 'keydown' &&
            ((event as React.KeyboardEvent).key === 'Tab' ||
              (event as React.KeyboardEvent).key === 'Shift')
          ) {
            return
          } else {
            setOpen(false)
          }
        }}
      >
        <Divider />
        <MenuItem
          text="プロフィール"
          Icon={AccountBoxIcon}
          onClick={() => navigate(`/profile/?${urlQuery}`)}
        />
        <Divider />
        <MenuItem
          text="イベント一覧"
          Icon={EventIcon}
          onClick={() => navigate(`/?${urlQuery}`)}
        />
        <MenuItem
          text="参加実績"
          Icon={QuizIcon}
          onClick={() => navigate(`/?${urlQuery}`)}
        />
        <Divider />
        <MenuItem
          text="ログアウト"
          Icon={LogoutIcon}
          onClick={() => dispatch(logout())}
        />
      </List>
    </Box>
  )

  return (
    <React.Fragment>
      <IconButton onClick={() => setOpen(true)} sx={{ color: '#fff' }}>
        <MenuIcon fontSize="large" />
      </IconButton>
      <Drawer anchor={'right'} open={open} onClose={() => setOpen(false)}>
        {list()}
      </Drawer>
    </React.Fragment>
  )
}
